import { createMuiTheme } from "@material-ui/core/styles"

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "rgba(0, 93, 107, 0.99)",
      contrastText: "#fff",
    },
    secondary: {
      main: "#ffa19f",
      contrastText: "#fff",
    },
    background: {
      default: "#f7f7f7",
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: [
      "AvenirLTStdBlack",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
})

export default theme
